module.exports = __webpack_public_path__ + "static/media/yuntaishan_web.a384bd23.png";